export const DevStateComMap = {
  'game-cover': 'GameCover',
  'game-index': 'GameIndex',
  //
  'game-hunting': 'GameHunting',
  'game-paper-making': 'GamePaperMaking',
  'game-compass': 'GameCampus',
  'game-printing': 'GamePrinting',
  'game-gunpowder': 'GameGunpowder',
  //
}

export type GameState = "cover" | "intro" | "description" | "messages" | "hints" | "success" | "fail";

export type State =
  | { status: 'game-cover', data?: any }
  | { status: 'game-paper-making', state: GameState, data?: any }
  | { status: 'game-compass', state: GameState, data?: any }
  | { status: 'game-printing', state: GameState, data?: any }
  | { status: 'game-gunpowder', state: GameState, data?: any }

export type Action =
  | { type: 'game-cover', data?: any }
  | { type: 'game-paper-making', state: GameState, data?: any }
  | { type: 'game-compass', state: GameState, data?: any }
  | { type: 'game-printing', state: GameState, data?: any }
  | { type: 'game-gunpowder', state: GameState, data?: any }

export const INITIAL_STATE: State = { status: 'game-cover' };

export const GameStateReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "game-cover":
      return { ...state, status: action.type };
    case "game-paper-making":
      return { ...state, status: action.type, state: action.state, data: action.data };
    case "game-compass":
      return { ...state, status: action.type, state: action.state, data: action.data };
    case "game-printing":
      return { ...state, status: action.type, state: action.state, data: action.data };
    case "game-gunpowder":
      return { ...state, status: action.type, state: action.state, data: action.data };
  }
  return state;
};
